// 葡萄牙
export default {
    login: {
        t01: 'Idioma',
        t02: 'Netflix',
        t03: 'Por favor, insira seu nome de usuário',
        t04: 'Insira sua senha',
        t05: 'Entrar',
        t06: 'Registrar-se',
        t07: 'Digite seu número de telefone',
        t08: 'Confirme sua senha',
        t09: 'Digite o código de convite',
        t10: 'Registrar conta',
        t11: 'Por favor confirme sua senha',
        t13: 'O amor pelo cinema pode fazer com que você acumule uma riqueza considerável sem nem perceber.',
        t14: 'Login bem-sucedido',
        t15: 'As senhas não coincidem',
        t16: 'Registro bem-sucedido',
        t17: 'Erro de rede',
        t18: 'Tempo limite esgotado, verifique sua conexão com a internet'
    },
    cover_info: {
        t01: 'Começar a ganhar',
        t02: 'Recarregar moedas',
        t03: 'Retirar moedas',
        t04: 'Certificados'
    },
    cont: {
        t01: 'Selecione o Idioma',
        t02: 'Todos',
        t03: 'Pendente',
        t04: 'Concluído',
        t05: 'Congelado',
        t06: 'Meu Saldo',
        t07: 'Incompleto',
        t08: 'Total de Pedidos',
        t09: 'Comissão',
        t10: 'Comissão Ganha',
        t11: 'Quantidade de Pedidos',
        t12: 'Saldo Disponível',
        t13: 'Começar a Resgatar Pedidos',
        t14: 'Fundos da Conta',
        t15: 'Enviar Pedido',
        t16: 'Enviar Todos os Pedidos',
        t17: 'Tempo de Resgate de Pedidos',
        t18: 'Número do Pedido',
        t19: 'Valor Total do Pedido',
        t21: 'Obra',
        t22: 'Ator',
        t23: 'Comentários sobre a obra',
        t24: 'Cancelar',
        t25: 'Por favor selecione uma avaliação',
        t26: 'Envio de pedido concluído',
        t27: 'Pedido Adquirido',
        t28: 'Resgate de Pedidos Bem-Sucedido',
        t29: 'Falha no Resgate de Pedidos, Tente Novamente!'
    }
    ,
    user: {
        t1: 'Código de Introdução',
        t2: 'Balanço',
        t3: 'Saldo Disponível',
        t4: 'Lucro Total',
        t5: 'Retirada de Dinheiro',
        t6: 'Histórico de Depósitos',
        t7: 'Histórico de Saques',
        t8: 'Detalhes da Conta',
        t9: 'Mensagem',
        t10: 'Vincule o Cartão do Banco',
        t11: 'Alterar Senha',
        t12: 'Alterar Senha de Saque',
        t13: 'Convide Amigos',
        t14: 'Selecionar Idioma',
        t15: 'Sair',
        t16: 'Retirada',
        t17: 'Quantidade a Retirar',
        t18: 'Nome da Conta',
        t19: 'Número de Telefone',
        t20: 'Quantidade a Ser Retirada',
        t21: 'Saque',
        t22: 'Insira a Quantidade a Ser Retirada',
        t23: 'Insira a Senha do Dinheiro Virtual',
        t24: 'Total de Depósitos',
        t25: 'Mensagens do Sistema',
        t26: 'Informações do Cartão do Banco',
        t27: 'Lista de Bancos',
        t28: 'Nome do Banco',
        t29: 'Apelido',
        t30: 'Número do Cartão do Banco',
        t31: 'Número de Telefone',
        t32: 'Confirmar Mudanças',
        t33: 'Por favor insira o número da conta e o número IFSC do cartão bancário que você vinculou, também preencha corretamente o nome e o número de telefone, caso contrário, o valor do depósito não chegará.',
        t34: 'Senha Antiga',
        t35: 'Nova Senha',
        t36: 'Confirmar Senha',
        t37: 'Continuar',
        t38: 'Por favor lembre-se da sua senha, se esqueceu a senha, entre em contato com o serviço ao cliente.',
        t39: 'Copiar Link de Convite',
        t40: 'Convide amigos para ganhar comissões',
        t41: 'Depósito',
        t42: 'Confirmar',
        t43: 'Cancelar',
        t44: 'Tem certeza que quer sair?',
        t45: 'Quantidade de Depósito',
        t46: 'Depósito Bem-Sucedido',
        t47: 'Verificado',
        t48: 'Aguardando Verificação',
        t49: 'Total de Saques',
        t50: 'Configure primeiro a senha de retirada',
        t51: 'Por favor insira a senha antiga',
        t52: 'Por favor insira a nova senha',
        t53: 'Por favor insira a confirmação da senha',
        t54: 'As duas senhas inseridas não correspondem',
        t55: 'Copiado',
        t56: 'O valor do levantamento não pode ser inferior a 30',
        t57: 'Enviado com sucesso, redirecionando',
        t58: 'Revisão falhou',
        t59: 'Definir Avatar',
        t60: 'Definir Agora',
        t61: 'Configuração bem-sucedida',
        t62: 'Depois da aprovação da carteira, você precisa fazer login para sacar dinheiro',
        t63: 'Saque para conta bancária',
        t64: 'Saque para USDT (proporção 1:0.013)',
        t65: 'Número da Conta Bancária',
        t66: 'Por favor, insira o número da conta bancária e o código IFSC para o cartão bancário que deseja vincular, bem como seu nome completo e número de telefone móvel. Certifique-se de que todas as informações são precisas para facilitar transações de pagamento fluidas.',
        t67: 'Por favor, vincule o cartão bancário primeiro',
        t68: 'Usuário recarregar',
        t69: 'Usuário aceitar pedidos',
        t70: 'Comissão de subordinados',
        t71: 'Usuário retirar dinheiro',
        t72: 'Transferir para Yebao',
        t73: 'Transferir de Yebao',
        t74: 'Ganhos do Yebao',
        t75: 'Comissão de aceitação de pedidos',
        t76: 'Saldo abaixo de 30, não é possível continuar a negociação, por favor, entre em contato com o atendimento ao cliente',
        t77: 'Por favor, insira o nome do banco',
        t78: 'Por favor, insira o número da conta bancária',
        t80: 'Por favor, insira seu nome completo',
        t81: 'Por favor, insira seu número de telefone',
        t82: 'Por favor, insira a quantidade de saque',
        t83: 'Copiar',
        t84: 'Top 100 diário: global',
        t85: 'Ouvir',
        t86: "Email",
        t87: "Por favor, insira seu email",
        "t88": "Código do banco",
        "t89": "Por favor, insira o código do banco",
        t90: 'Transferência bancária',
        t91: '1. Nenhuma taxa é exigida para saques',
        t92: '2. A retirada será recebida com sucesso dentro de 10 a 15 minutos após a retirada. Para saques após o horário comercial, o recebimento será feito no próximo horário comercial.'
    },
    movie: {
        t01: 'Filmes e programas de TV populares',
        t02: 'Senha de fundos',
        t03: 'Diferença do pedido',
        t04: 'Gerenciamento de endereços on-chain',
        t05: 'Por favor, insira',
        t06: 'Por favor, insira o endereço on-chain correto e a rede correspondente (por exemplo, ERC20/TRC20/BTC); caso contrário, o pagamento/a transferência pode não chegar ou resultar em perda de ativos.',
        t07: 'Sacar para um endereço on-chain',
        t08: 'Por favor, adicione',
        t09: 'Por favor, adicione um endereço on-chain',
    },
    langType: '葡萄牙语'
}
